import React, { useEffect, useState, useContext } from "react";
import BookCard from "../components/cards/BookCard";
import "./style/Browse.css";
import { Context } from "../components/context/Context";
import axios from "axios";
import Loading from "../components/Loading";

function Browse() {
  const [books, setBooks] = useState();
  const [term, setTerm] = useContext(Context);

  useEffect(() => {
    const data = axios
      .get(
        `https://www.googleapis.com/books/v1/volumes?q=${term}&maxResults=40`
      )
      .then((res) => res.data.items)
      .then((res) => setBooks(res));
  }, [term]);

  return (
    <div className="browse">
      {books ? (
        books?.map((book) => {
          return (
            <BookCard
              key={book.id}
              src={
                !book.volumeInfo.imageLinks?.thumbnail
                  ? "https://via.placeholder.com/90x90.png"
                  : book.volumeInfo.imageLinks.thumbnail
              }
              title={book.volumeInfo.title}
              rating={book.volumeInfo.averageRating}
              prix={
                book.saleInfo.saleability === "NOT_FOR_SALE"
                  ? 30
                  : book.saleInfo.saleability
              }
              author={book.volumeInfo.authors}
              desc={book.volumeInfo.description}
              id={book.id}
            />
          );
        })
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default Browse;
